import * as React from 'react'
import { type SVGProps } from 'react'
const ExpandIcon = (props: SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={24}
    height={24}
    fill='none'
    {...props}
  >
    <path
      fill='#283036'
      d='M15.14 0h6.985A1.88 1.88 0 0 1 24 1.875v6.984c0 .938-.75 1.641-1.688 1.641-.421 0-.843-.14-1.171-.469L19.875 8.72l-2.906 2.906c-.89.89-2.344.89-3.188 0l-1.406-1.406a2.18 2.18 0 0 1 0-3.14l2.906-2.954-1.312-1.266a1.627 1.627 0 0 1-.469-1.171C13.5.75 14.203 0 15.14 0Zm2.532 3.328-.047.047a1.026 1.026 0 0 1 0 1.547l-3.703 3.703 1.453 1.453 3.703-3.703c.422-.469 1.125-.469 1.594 0l1.078 1.078V2.25h-5.156l1.078 1.078ZM8.812 24H1.875C.797 24 0 23.203 0 22.125v-6.938C0 14.25.703 13.5 1.64 13.5c.423 0 .844.188 1.173.516l1.312 1.312 2.906-2.953c.844-.844 2.297-.844 3.14 0l1.454 1.406c.844.89.844 2.344 0 3.188l-2.953 2.906 1.312 1.313c.329.328.516.75.516 1.171 0 .938-.75 1.641-1.688 1.641Zm-2.484-3.328c-.469-.422-.469-1.125 0-1.594l3.703-3.703-1.453-1.406-3.703 3.703a1.027 1.027 0 0 1-1.547 0L2.25 16.594v5.156h5.156l-1.078-1.078Z'
    />
  </svg>
)
export default ExpandIcon
